import "./App.css";
import HomePage from "./pages/HomePage";
import Footer from "./Components/Footer/Footer";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Experience from "./pages/Experience";
import Services from "./pages/Services";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import Login from "./Components/Login/Login";
import Contact from "./Components/Contact/Contact";
import Signup from "./Components/Signup/Signup";
import NavBar from "./Components/Navbar/Navbar";
import CreateBlog from "./pages/CreateBlog";
import GoogleCallback from "./pages/GoogleCallback";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./routes/ProtectedRoute";
import Profile from "./pages/Profile";
import UserAvatarUpload from "./pages/useAvatarUpload";
import AdminLogin from "./Components/AdminLogin/AdminLogin";
import AdminDashboard from "./Components/AdminDashboard/AdminDashboard";
import AdminResumeUpload from "./pages/AdminResumeUpload";
import ProjectDetail from './pages/ProjectDetail';
import Certifications from "./pages/Certifications";
import ProjectFeed from "./Projects/ProjectDetailPage";
import AIAssistant from "./Components/AIAssistant/AIAssistant";
import ChatPage from "./pages/ChatPage";

function App() {
  return (
    <>
      <Router>
        <SpeedInsights />
        <Analytics />
        {/* <NavBar/> */}
        <NavBar />
        <Routes>
          <Route path="/nav" element={<NavBar />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/services" element={<Services />} />
          <Route path="/certificates" element={<Certifications />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/create"
            element={
              <ProtectedRoute>
                <CreateBlog />
              </ProtectedRoute>
            }
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/projectsDetails/:id" element={<ProjectFeed />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
<Route
  path="/admin/dashboard"
  element={
    <ProtectedRoute requiredRole="admin">
      <AdminDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/upload-resume"
  element={
    <ProtectedRoute requiredRole="admin">
      <AdminResumeUpload />
    </ProtectedRoute>
  }
/>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />
          <Route path="/uploadavatar" element={<UserAvatarUpload />} />
          <Route path="/chat" element={<ChatPage />} />
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
        <AIAssistant />
        <FooterWithLocation />
      </Router>
    </>
  );
}


// Helper component to use useLocation inside Router context
function FooterWithLocation() {
  const location = useLocation();
  return (
    <>
      {["/login", "/signup", "/profile", "/contact"].includes(
        location.pathname
      ) ? null : (
        <Footer />
      )}
    </>
  );
}

export default App;
